import SetRoute from '../services/setRoute';

export const fetchFeaturedProductUpdates = (fetch, paramsStr = '') => {
    let route = SetRoute + '/api/v1/product_updates?is_featured=true';

    if (paramsStr) {
        route += `&${paramsStr.replace('?', '')}`;
    }

    return {
        payload: {
            dataset: 'featured_product_updates',
            action: 'get',
            route,
            data: {},
        },
        fetch,
    };
};
